import { useState, useRef, useEffect } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { FiExternalLink } from "react-icons/fi";
import {
  Header_Menu_Items,
  CORPORATE_SITE,
  TOOLS_SITE,
} from "../../constant/HeaderData";
import { NavLink } from "react-router-dom";

const itemClass =
  "block w-full text-left text-white hover:text-black px-4 py-2 hover:bg-[var(--website-secondary-color)] transition-colors rounded";

const HeaderMobileView = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative pr-3 lg:hidden" ref={menuRef}>
      {/* Plain button rather than MUI's IconButton — see ChatSection.jsx for
          why the dependency went. Tailwind reproduces the circular hit area. */}
      <button
        type="button"
        onClick={toggleMenu}
        className="rounded-full p-2 text-white transition-colors hover:bg-white/10
                   focus-visible:outline focus-visible:outline-2
                   focus-visible:outline-[var(--website-secondary-color)]"
        aria-label="Menu"
        aria-expanded={menuOpen}
      >
        <GiHamburgerMenu size={30} aria-hidden="true" />
      </button>

      {menuOpen && (
        <nav className="absolute top-14 bg-[var(--website-primary-color)] shadow-lg rounded-lg w-72 z-20">
          <ul className="space-y-1 p-4">
            {Header_Menu_Items.map((item) => (
              <li key={item.pageId}>
                {item.external ? (
                  <a
                    href={item.pageId}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${itemClass} flex items-center gap-2`}
                    onClick={() => setMenuOpen(false)}
                  >
                    {item.title}
                    <FiExternalLink size={14} />
                  </a>
                ) : (
                  <NavLink
                    to={item.pageId}
                    end={item.pageId === "/"}
                    className={itemClass}
                    onClick={() => setMenuOpen(false)}
                  >
                    {item.title}
                  </NavLink>
                )}
              </li>
            ))}
            <li className="pt-1 mt-1 border-t border-white/20">
              <a
                href={TOOLS_SITE.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`${itemClass} flex items-center gap-2`}
                onClick={() => setMenuOpen(false)}
              >
                {TOOLS_SITE.label}
                <FiExternalLink size={14} />
              </a>
            </li>
            <li>
              <a
                href={CORPORATE_SITE.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`${itemClass} flex items-center gap-2`}
                onClick={() => setMenuOpen(false)}
              >
                {CORPORATE_SITE.label}
                <FiExternalLink size={14} />
              </a>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
};

export default HeaderMobileView;
